import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { StepValidationMap } from 'sos-common/js/commonTypes/validation.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { StatisticsOrderModel } from '../../../models';
import {
  statisticsOrderFiles,
  StatisticsOrderRegisters,
  StatisticsOrderStore,
} from '../../../models/StatisticsOrderStore.types';
import SummaryStep from '../../../components/SummaryStep';
import SummaryStepFragment from '../../../components/SummaryStepFragment';
import { saveFormOrder } from 'sos-eservice-common/js/Redux/Actions';
import { makeTranslator, translateFunc } from '../../../utilities/translations';
import { areAllFieldsErrorFree } from '../../../utilities/helpers';
import { countryList } from './dhsCountries';
import { PrintButton } from 'sos-common/js/components/PrintButton/PrintButton';
import SendButton from 'sos-common/js/components/FormControls/SendButton';
export interface Step3Props extends StepChildProps {
  Translate?: translateFunc;
  files: statisticsOrderFiles;
  validationResults: ValidationResult[];
  stepValidationMap: StepValidationMap;
  orderId: string;
  formModel: StatisticsOrderModel;
  registers?: StatisticsOrderRegisters;
  saveFormOrder: typeof saveFormOrder;
  isSending: boolean;
}

export interface Step3State {}

class Step3 extends React.Component<Step3Props, Step3State> {
  constructor(props: any) {
    super(props);

    this.state = {};
  }

  getTitle = () => 'Granska och skicka in';

  componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle(),
    });
  }

  getRegisterNameFromId = (id: number): string => {
    const { internalRegistriescauseOfDeath, internalRegistrieshealthData, internalRegistriessocialServices } =
      this.props.registers;
    const allRegistries = []
      .concat(internalRegistriescauseOfDeath)
      .concat(internalRegistrieshealthData)
      .concat(internalRegistriessocialServices);

    const item = allRegistries.find((r) => r.DhsId === id);
    if (item === null || item === undefined) {
      return '';
    }
    return item.Name;
  };

  getRegisterNamesFromArray = (registers: number[]): string => {
    const result = registers.map((reg) => this.getRegisterNameFromId(reg));
    let joined = result.join('. ');
    if (registers.length > 0) {
      joined = joined + '. ';
    }
    return joined;
  };

  getCountryNameFromCode = (countryCode: string): string => {
    if (!countryCode) {
      return '';
    }
    return countryList.find((c) => c.Landkod === countryCode)?.Land ?? '';
  };

  getFormValue = (formName: string, detailedFormName = null): string => {
    let value: string = _.get(this.props.formModel, formName);
    if (value === null || value === undefined || value === '' || value.length === 0) {
      value = this.props.Translate('/general/forms/uppSaknas');
      if (detailedFormName !== null) {
        value = detailedFormName + ' saknas';
      }
    }
    value = String(value); // don't delete this line :p
    switch (value) {
      case 'false':
        value = 'Nej';
        break;
      case 'true':
        value = 'Ja';
        break;
      case 'PNumber':
        value = 'Personnummer';
        break;
      case 'Number':
        value = 'Löpnummer';
        break;
      case 'NumberSaved':
        value = 'Löpnummer med sparad löpnummernyckel';
        break;
    }
    return value;
  };
  validateFields = (...fieldNames: string[]): boolean => {
    const { validationResults } = this.props;
    return areAllFieldsErrorFree(validationResults, ...fieldNames);
  };

  onClickSave = (e: React.MouseEvent) => {
    e.preventDefault();
    this.props.saveFormOrder();
  };

  getContactPersonFields() {
    return [
      'ContactPerson.Name',
      'ContactPerson.Organisation',
      'ContactPerson.Email',
      'ContactPerson.Phone',
      'ContactPerson.CountryCode',
    ];
  }

  getBillingDetailsFields() {
    return [
      'BillingDetails.Organisation',
      'BillingDetails.OrganisationNumber',
      'BillingDetails.BillingReference',
      'BillingDetails.BillingAddress.StreetAddress',
      'BillingDetails.BillingAddress.ZipCode',
      'BillingDetails.BillingAddress.City',
      'BillingDetails.BillingAddress.Country',
    ];
  }

  render() {
    const { Translate, formModel, files, orderId, validationResults, registers, navProps } = this.props;
    const noOrderId = !orderId;
    const sendDisabled = validationResults && validationResults.length > 0 ? true : false;
    return (
      <div id="step3" tabIndex={-1}>
        <h2>{Translate('/general/forms/summering')}</h2>
        <PrintButton />
        <div className="form-summary">
          <SummaryStep
            stepId={0}
            goToStep={navProps.goToStep}
            isDone={_.get(this.props.stepValidationMap, '[0].isValid', false)}
            headerTitle="Projektet"
            headerBackString={Translate('/general/navigering/gaTillSteg1')}>
            <SummaryStepFragment isValid={this.validateFields('Title')}>
              <div>
                <strong>{Translate('/statisticsOrderFormPage/titleSUM')}</strong>
                <br />
                {this.getFormValue('Title')}
              </div>
            </SummaryStepFragment>
            <SummaryStepFragment isValid={this.validateFields('IsUpdateOfPriorOrder')}>
              <div>
                <strong>{Translate('/statisticsOrderFormPage/updatePrior')}</strong>
                <br />
                {this.getFormValue('IsUpdateOfPriorOrder')}
                {this.getFormValue('IsUpdateOfPriorOrder') === 'Ja' && (
                  <span>
                    <br />
                    {/* {Translate('/statisticsOrderFormPage/priorOrderRefPH')}:  */}
                    {this.getFormValue('PriorOrderReference', 'Hänvisning (ej obligatorisk)')}
                  </span>
                )}
              </div>
            </SummaryStepFragment>

            <SummaryStepFragment isValid={this.validateFields('FrequencyOfDeliveries')}>
              <div>
                <strong>{Translate('/statisticsOrderFormPage/hurOftaSUM')}</strong>
                <br />
                {this.getFormValue('FrequencyOfDeliveries')}
              </div>
            </SummaryStepFragment>

            <SummaryStepFragment
              isValid={true}
              showNotObligatoryIcon={
                this.getFormValue('AdditionalInformation') === this.props.Translate('/general/forms/uppSaknas')
              }>
              <div>
                <strong>{Translate('/statisticsOrderFormPage/angeInformationSUM')}</strong>
                <br />
                <span className="form-summary__multiline-format">{this.getFormValue('AdditionalInformation')}</span>
              </div>
            </SummaryStepFragment>

            <SummaryStepFragment isValid={this.validateFields('Registers')}>
              <div>
                <strong>{Translate('/statisticsOrderFormPage/vilkaregisterSUM')}</strong>
                <br />
                {formModel.Registers.length === 0 && <div>{Translate('/general/forms/uppSaknas')}</div>}
                {formModel.Registers.map((register) => {
                  const name = this.getRegisterNameFromId(register);
                  return <div key={register}> {name} </div>;
                })}
              </div>
            </SummaryStepFragment>

            <SummaryStepFragment isValid={this.validateFields('Constraints')}>
              <div>
                <strong>{Translate('/statisticsOrderFormPage/beskrivnogaSUM')}</strong>
                <br />
                <span className="form-summary__multiline-format">{this.getFormValue('Constraints')}</span>
              </div>
            </SummaryStepFragment>

            <SummaryStepFragment isValid={this.validateFields('Presentation')}>
              <div>
                <strong>{Translate('/statisticsOrderFormPage/beskrivtabellSUM')}</strong>
                <br />
                <span className="form-summary__multiline-format">{this.getFormValue('Presentation')}</span>
              </div>
            </SummaryStepFragment>

            <SummaryStepFragment isValid={true} showNotObligatoryIcon={files.exempelltabell.length === 0}>
              <div>
                <strong>{Translate('/statisticsOrderFormPage/uploadheader')}</strong>
                <br />
                {files.exempelltabell.length === 0 && Translate('/general/forms/uppSaknas')}
                {files.exempelltabell.map((file) => {
                  return (
                    <div
                      className="file-extension-icon form-summary__extension-icon"
                      key={`step1filenames_${file.FileId}`}>
                      {file.OriginalFilename}
                    </div>
                  );
                })}
              </div>
            </SummaryStepFragment>
          </SummaryStep>

          <SummaryStep
            stepId={1}
            goToStep={navProps.goToStep}
            isDone={_.get(this.props.stepValidationMap, '[1].isValid', false)}
            headerTitle="Beställare"
            headerBackString={Translate('/general/navigering/gaTillSteg2')}>
            <SummaryStepFragment isValid={this.validateFields(...this.getContactPersonFields())}>
              <div>
                <strong>{Translate('/statisticsOrderFormPage/Bestallare')}</strong>
                <br />
                {this.getFormValue('ContactPerson.Name', 'Namn')}
                <br />
                {this.getFormValue('ContactPerson.Organisation', 'Organisation')}
                <br />
                {this.getFormValue('ContactPerson.Email', 'E-postadress')}
                <br />
                (+{this.getFormValue('ContactPerson.CountryCode')}){' '}
                {this.getFormValue('ContactPerson.Phone', 'Telefonnummer')}
              </div>
            </SummaryStepFragment>

            <SummaryStepFragment isValid={this.validateFields(...this.getBillingDetailsFields())}>
              <div>
                <strong>{Translate('/statisticsOrderFormPage/BillingTitle')}</strong>
                <br />
                {this.getCountryNameFromCode(this.getFormValue('BillingDetails.BillingAddress.Country', 'Land'))}
                <br />
                {this.getFormValue('BillingDetails.Organisation', 'Organisation')}
                <br />
                {this.getFormValue('BillingDetails.OrganisationNumber', 'Organisationsnummer/VAT-nummer')}
                <br />
                {this.getFormValue('BillingDetails.BillingReference', 'Fakturareferens')}
                <br />
                {this.getFormValue('BillingDetails.BillingAddress.StreetAddress', 'Fakturaadress (ej obligatorisk)')}
                <br />
                {this.getFormValue('BillingDetails.BillingAddress.ZipCode', 'Postnummer')}
                <br />
                {this.getFormValue('BillingDetails.BillingAddress.City', 'Ort')}
                <br />
              </div>
            </SummaryStepFragment>
          </SummaryStep>
        </div>
        <div className="form-submit">
          <SendButton onClickSave={this.onClickSave} isSending={this.props.isSending} sendDisabled={sendDisabled} />
        </div>
      </div>
    );
  }
}

const mapState2Props = (state: StatisticsOrderStore) => {
  return {
    files: state.files,
    formModel: state.formModel,
    registers: state.registers,
    stepValidationMap: state.validationState.stepValidationMap,
    Translate: makeTranslator(state.globals.translations),
    validationResults: state.validationState.validationResults,
    isSending: state.globals.isSending,
  } as Partial<Step3Props>;
};

const mapDispatch2Props = (dispatch) => {
  return {
    saveFormOrder: bindActionCreators(saveFormOrder, dispatch),
  } as Partial<Step3Props>;
};

const StepThree = connect(mapState2Props, mapDispatch2Props)(Step3);
export { StepThree };
